import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ExternalLink, ArrowLeft } from 'lucide-react'

const AWP_URL = 'https://awp.posteitaliane.it/switch'

export default function CambioPorte() {
  const navigate = useNavigate()

  useEffect(() => {
    window.open(AWP_URL, '_blank', 'noopener,noreferrer')
  }, [])

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      height: '100%', gap: 24, padding: 32,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: 40, maxWidth: 420, width: '100%',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center', border: '1px solid #e5e7eb',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔀</div>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1E40AF', marginBottom: 8 }}>Cambio Porte</h2>
        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 24, lineHeight: 1.6 }}>
          Il sito AWP Poste Italiane è stato aperto in una nuova finestra.<br />
          Se non si è aperto automaticamente, clicca il bottone qui sotto.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <a
            href={AWP_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              padding: '12px 24px', background: '#1E40AF', color: '#fff', borderRadius: 10,
              fontWeight: 700, fontSize: 14, textDecoration: 'none',
              boxShadow: '0 2px 8px rgba(30,64,175,0.3)',
            }}
          >
            <ExternalLink size={16} /> Apri AWP Poste Italiane
          </a>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              padding: '10px 24px', background: '#f1f5f9', color: '#374151', border: 'none',
              borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: 'pointer',
            }}
          >
            <ArrowLeft size={15} /> Torna indietro
          </button>
        </div>
      </div>
    </div>
  )
}
